export default __webpack_public_path__ + "static/media/luke_Ichpekov_Resume.9d352a76.pdf";